import { DataBean } from "../DataBean";

export class DocumentAffiliateRecord extends DataBean {

    public async getDocumentCreditByAffiliate(idAccount:number): Promise<any> {
        return this.getCustomService("CreditCore", "java.util.List_getDocumentCreditByAffiliate_Number", 
            [idAccount]);
    }
    public async updateDocumentAffiliateRecord(bean:any): Promise<any> {
        return this.getCustomService("CreditCore", "com.credit.bean.DocumentAffiliateRecord_updateDocumentAffiliateRecord_com.credit.bean.DocumentAffiliateRecord", 
            [
                {
                    DataBeanProperties:bean,
                    DataBeanName:"com.credit.bean.DocumentAffiliateRecord"
                }
            ]);
    }
   
}
